module.exports = __webpack_public_path__ + "img/1_4.2aebb3f6.png";